import { useIsAdmin } from "@/hooks/survey-factory-contract/useIsSurveyAdmin";
import { Navigate, Outlet } from "react-router-dom";
import { useAccount } from "wagmi";

function AdminGuard() {
    const { isConnecting, isConnected, address } = useAccount()
    const { data: adminAccount, isLoading } = useIsAdmin(address!)
    
    if(isConnecting || isLoading) return <p>Loading...</p> // TODO: add a fallback

    if(!isConnected) return <Navigate to={"/"} />
    
    return adminAccount ? <Outlet /> : <Navigate to={"/"} />
}


export default AdminGuard 